import { Params } from 'react-router-dom';

export const processRouterParams = (
  url: string,
  isInternal: boolean,
  params: Params
): string => {
  if (!isInternal) return url;
  let newUrl = url;
  Object.keys(params).forEach(key => {
    newUrl = newUrl.replace(`:${key}`, params[key] ?? '');
  });
  return newUrl;
};
